import React from 'react';
import { ErrorState, LoadingState, PageHeader } from '@/components/primitives';
import MitreHeatmap from '@/components/MitreHeatmap';
import { useTimeRange } from '@/context/TimeRangeContext';
import AnalyticsTab from '@/pages/dashboard/AnalyticsTab';
import HuntTab from '@/pages/dashboard/HuntTab';
import useResource from '@/pages/dashboard/useResource';
import { apiGet } from '@/pages/dashboard/api';

/*
 * One page per job, replacing the old Briefing tabs. Each reads the workspace
 * time range from the top bar, so a number here and the same number on Home
 * describe the same period.
 */

function useWindow() {
  const { days, range } = useTimeRange();
  return { days, range, params: { since_days: days }, label: `in the ${range.label.toLowerCase()}` };
}

export function AnalyticsPage() {
  const w = useWindow();
  const analytics = useResource(() => apiGet('/dashboard/analytics', w.params), [w.days]);
  return (
    <div className="pg" data-testid="analytics-page">
      <PageHeader title="Analytics" subtitle="What changed, what stands out and how your team is responding, for the selected time range." />
      {analytics.loading && !analytics.data ? <LoadingState label="analytics" rows={5} />
        : analytics.error && !analytics.data ? <ErrorState title="Couldn't load analytics" error={analytics.error} onRetry={analytics.reload} />
          : <AnalyticsTab analytics={analytics.data} windowLabel={w.label} />}
    </div>
  );
}

export function AttackPage() {
  const w = useWindow();
  const mitre = useResource(() => apiGet('/dashboard/mitre-coverage', w.params), [w.days]);
  return (
    <div className="pg" data-testid="attack-page">
      <PageHeader title="ATT&CK" subtitle="How the threats matched to you operate, mapped to MITRE ATT&CK tactics." />
      <MitreHeatmap resource={mitre} windowLabel={w.range.label} />
    </div>
  );
}

export function HuntingPage() {
  const campaigns = useResource(() => apiGet('/dashboard/threat-hunt-campaigns'), []);
  return (
    <div className="pg" data-testid="hunting-page">
      <PageHeader title="Threat hunting" subtitle="Campaigns reviewed by the IntelliSecure team, with ready-to-run queries for your SIEM and indicator downloads." />
      <HuntTab resource={campaigns} />
    </div>
  );
}
